import { FC } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { styled } from 'styled-components';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

import 'react-multi-carousel/lib/styles.css';
import { OFICINA } from '../../config/constants';
import { rojoRemaxAlt } from '../../styled/const';
const Title = styled.h3`
  font-size: 48px;
  font-weight: 600;
  text-transform: none;
  font-style: normal;
  text-decoration: none;
  line-height: 1.2em;
  letter-spacing: 0px;
  word-spacing: 0em;
  color: #000;
  text-align: center;
  margin-bottom: 3px;
`;
const TitleItems = styled.h4`
  font-family: 'Poppins';
  font-size: 22px;
  font-weight: 600;
  text-transform: capitalize;
  font-style: normal;
  text-decoration: none;
  line-height: 1.2em;
  letter-spacing: 0px;
  word-spacing: 0em;
  color: #000;
`;
const DescItems = styled.strong`
  color: #324a6d;
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 300;
  text-transform: none;
  font-style: normal;
  text-decoration: none;
  line-height: 1.5em;
  letter-spacing: 0px;
  word-spacing: 0em;
`;

const ContainerItems = styled(Container)`
  text-align: center;
`;

const IntoFilo: FC<{ isMobile: boolean; isTablet: boolean; isDesktop: boolean }> = ({
  isMobile,
  isTablet,
  isDesktop
}) => {
  return (
    <section id="corazon" className="bg-white" style={{ padding: '1em 0' }}>
      <Container className="mt-5 mb-5">
        <Title className='font-main'>
          Descubrí el corazón de <strong> {`${OFICINA}`}</strong>
        </Title>
        <p
          style={{
            fontSize: '1.5em',
            marginTop: '1em',
            textAlign: 'center'
          }}
          className='font-main'
        >
          En este video te invitamos a conocer nuestra esencia, nuestro equipo y nuestra forma de trabajar. Descubrí
          cómo vivimos día a día la pasión por ayudar a las personas a cumplir sus sueños inmobiliarios, con compromiso,
          profesionalismo y un trato humano que nos distingue.
        </p>
        <Container style={{ textAlign: 'center' }} class="mb-5 mt-5">
          <iframe
            // width="853"
            // height="480"
            width={isMobile ? '100%' : isTablet ? '100%' : '75%'}
            height={isMobile ? '250' : isTablet ? '350' : '500'}
            src="https://www.youtube.com/embed/FRQJRXNobrA?autoplay=1"
            title="Pantallas 2"
            //   frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            //   referrerpolicy="strict-origin-when-cross-origin"
            //   allowfullscreen
          ></iframe>
        </Container>
      </Container>
    </section>
  );
};
export default IntoFilo;
